import { useCallback, useEffect, useRef } from 'react';

/**
 * bounds dnd-kit autoscroll to an elements client rect plus or minus some buffer
 * return true if autoscroll should happen, false otherwise
 */
export const useBoundAutoScroll = (
  {
    bufferX,
    bufferY,
  }: {
    bufferX: number;
    bufferY: number;
  } = { bufferX: 0, bufferY: 0 }
) => {
  const rectMapRef = useRef(new WeakMap<HTMLElement, DOMRect>());

  const coordsRef = useRef<[number, number]>([0, 0]);

  useEffect(() => {
    const onPointerMove = (event: PointerEvent) => {
      coordsRef.current = [event.clientX, event.clientY];
    };

    window.addEventListener('pointermove', onPointerMove);

    return () => {
      window.removeEventListener('pointermove', onPointerMove);
    };
  }, []);

  return useCallback(
    (el: HTMLElement) => {
      let rect = rectMapRef.current.get(el as HTMLElement);
      const [xMouse, yMouse] = coordsRef.current;
      if (!rect) {
        rect = (el as HTMLElement)?.getBoundingClientRect();
        rectMapRef.current.set(el as HTMLElement, rect);
      }
      if (
        xMouse > rect.left - bufferX &&
        xMouse < rect.right + bufferX &&
        yMouse > rect.top - bufferY &&
        yMouse < rect.bottom + bufferY
      ) {
        return true;
      }
      return false;
    },
    [bufferX, bufferY]
  );
};
